<template>
  <div v-if="isDesktop">
    <div class="cluster-meta cluster-desktop">
      <div v-if="focusCountries" class="aside-section map">
        <DotMap :focusCountries="focusCountries" :flexWidth="true" />
      </div>

      <div class="aside-section">
        <div class="inner-section">
          <div class="feature-tags" v-if="getCurrentStory.topics.length > 0">
            <TopicTag :data-key="tag.topic_code" :data="tag" v-for="tag in getCurrentStory.topics.slice(0, 5)" :key="tag.topic_code" class="feature-tag"/>
          </div>
        </div>

        <div class="inner-section">
          <div class="story-sources">
            <p v-html="getSourcesHtml" @click="showSources()"></p>
          </div>
        </div>
      </div>

      <div class="aside-section story-timeline" v-if="getTimeline.length">
        <h4>Recent events within this story</h4>
        <ul class="timeline">
          <li v-for="(item, i) in getTimeline" :key="`${item.slug}:${i}`" class="item">
            <strong class="when">{{ item.timestamp | timeline }}</strong>
            <span class="description">{{ item.name }}</span>
          </li>
        </ul>
      </div>

      <div class="aside-section cta" v-if="!isSignedIn"> <!-- || !isPro -->
        <div v-if="!isSignedIn" class="mobile-cta">
          <El state="sign-up"/>
        </div>

        <!-- <div v-if="isSignedIn && !isPro" class="mobile-cta">
          <El state="go-pro"/>
        </div> -->
      </div>


      <div class="aside-group" v-if="isDesktop">
        <div v-if="isSignedIn" class="aside-section">
          <Dial />
        </div>

        <div class="aside-section qr" v-if="!hasApp">
          <QRCode />
        </div>
      </div>
      
      
      <!-- <div class="inner top"> -->
        
        <!-- <div class="story-timeline" v-if="getTimeline.length">
          <h4>Timeline</h4>
          <ul class="timeline">
            <li v-for="(item, i) in getTimeline" :key="`${item.slug}:${i}`" class="item">
              <strong class="when">{{ item.timestamp | timeline }}</strong>
              <span class="description">{{ item.name }}</span>
            </li>
          </ul>
        </div> -->

        <!-- <div class="cta-states" v-if="!isPro || !isSignedIn">
          <div class="inner-section section-cta section-sign-up" v-if="!isSignedIn">
            <div class="inner-section-content" @click="showSignUp">
              <div class="inner-content">
                <p><span class="callout">Get free updates</span><br/>See the story evolve.</p>
              </div>
              <button>Join for free</button>
            </div>
          </div>

          <div class="inner-section section-cta section-go-pro" v-if="isSignedIn && !isPro">
            <div class="inner-section-content" @click="goPro">
              <div class="inner-content">
                <p><span class="callout">Unlock the full story.</span><br/>Become a Pro & help us fix news.</p>
              </div>
              <button>Go Pro</button>
            </div>
          </div>
        </div>

        <div class="key-updates">
          <div class="go-back" @click="didSelectBack()">
            <global-svg class="icon" type="back-arrow" color="#16191c"></global-svg>
          </div>
          <div class="key-update">{{ metaPublishers }} {{ metaPublishers | plural('source') }}</div>
          <div class="key-update">{{ metaUpdates }} key story {{ metaUpdates | plural('update') }}</div>
          <div class="key-update">{{ Math.ceil(metaRunningTime) }} {{ Math.ceil(metaRunningTime) | plural('day') }} of reporting</div>
        </div> -->

        <!-- <div class="track">
          <TrackStory/>
        </div> -->

        <!-- <div class="tags"> -->
          <!-- <div class="tag" v-for="(topic, idx) in getCurrentStory.topics.slice(0, 4)" :key="idx">
            <TopicTag v-if="topic.topic_name" :topic="topic"/>
          </div> -->
        <!-- </div> -->

        <!-- <div class="updated-read-state" xxv-if="clusterReadState(clusterIndex).code">
          <span>
            Last read <span class="callout">{{ ago(getReadState(slug).date) }}</span> 
            <span v-if="getReadState(slug).updated"> and updated <span class="callout">{{ ago(getReadState(slug).updated) }} </span></span>
          </span>
        </div>-->

      <!-- </div> -->
      
      <!-- <div class="inner bottom cluster-bottom"> -->
        <!-- <Share :shareUrl="`story/${slug}/${node}`" :shareMessage="headline" :story="{slug: slug, node: node}"/>
        <div class="progress">
          <ProgressTag v-if="getPrimarySlug" :slug="getPrimarySlug" :active="true" class="progress-tag"/>
        </div> -->
        
        <!-- <div v-if="!isSignedIn" class="mobile-cta">
          <El state="sign-up"/>
        </div>

        <div v-if="isSignedIn && !isPro" class="mobile-cta">
          <El state="go-pro"/>
        </div> -->

        <!-- <div style="display: flex;">
          <Share v-if="getCloseButtonContext != 'modal'" :shareUrl="`/story/${slug}/`" class="share-btn" :shareMessage="headline" :story="{slug: slug, node: node}"/>
          <button v-if="getCloseButtonContext != 'modal'" @click="closeStory">{{ getCloseButtonText }}</button>
        </div> -->

        <!-- <div class="inner-dial" @click="didSelectMobileDial" v-if="a11yDialOn">
          <h3>Today's news diet</h3>
          <dial size="medium" class="dial-medium"/>
          <dial size="small" class="dial-small"/>
        </div>
        <div class="next-story">
          <Story v-if="getNextStory" class="inner-story" :story="getNextStory"/>
        </div> -->
      <!-- </div> -->

      <!-- <div class="goal-overlay" :class="{'fold-out': showGoalOverlay}">
        <h3>Today's news diet</h3>
        <dial size="medium" class="dial-medium" v-if="showGoalOverlay"/>
      </div> -->
    </div>

    <!-- <div class="cluster-meta cluster-mobile cluster-bottom" v-on:click="headClick" v-if="this.getCloseButtonContext != 'modal'">
      <Share :shareUrl="`/story/${slug}`" class="share-btn" :shareMessage="headline" :story="{slug: slug, node: node}"/>
      <button @click="closeStory">{{ getCloseButtonText }}</button>
    </div> -->

    <!-- <div class="cluster-meta cluster-mobile" v-on:click="headClick">
      <div class="node-header-mini">
        <div class="content">
          <h1>{{getCurrentStory.name}}</h1>
          <div class="content-meta">
            <global-svg type="clock" class="icon" height="12px"/>
            <span class="meta-byline">Last updated <span class="callout">{{ago(getCurrentStory.last_published_at)}}</span></span>
          </div>
        </div>

        <div class="read-status">
          <global-svg class="icon" :type="getReadStateIcon(readState.code)" :color="getReadStateColor(readState.code)" width="11px" height="11px"/>
        </div>
      </div>

      <div class="node-header-mini-progress" :style="{width: getNodeProgress}"></div>
    </div> -->
  </div>
</template>

<script>
  import utils from '@assets/js/utils.js';
  import layout from '@assets/js/layout.js';
  import story from '@assets/js/news/story-utils.js';
  // import TrackStory from 'app/components/_v4.5/content/story/TrackStory.vue'
  // import ProgressTag from 'app/components/_v5/grid-elements/meta/ProgressTag.vue' 
  // import Share from "@/components/_v5/base/Share"
  import TopicTag from 'app/components/_v5/grid-elements/meta/TopicTag.vue' 
  import El from '@/components/_v5/cta/El.vue';
  import QRCode from '@/components/v5/desktop/elements/QRCode.vue';
  import Dial from '@/components/v5/desktop/elements/Dial.vue';
  import DotMap from '@/components/v5/dotmap/DotMap.vue';

  export default {
    mixins: [story, utils, layout],
    props: {
      slug: String,
      node: String,
      clusterIndex: Number,
      focus: Boolean,
      type: String,
    },

    data() {
      return {
        showGoalOverlay: false,
        iScrollPos: 0,
        sources: {}
      }
    },

    components: {
      // TrackStory,
      // ProgressTag,
      // Share,
      TopicTag,
      El,
      Dial,
      QRCode,
      DotMap,
    },

    computed: {
      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },
      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },
      isPro() {
        return this.$store.getters.isPro;
      },

      getPrimarySlug() {
        return this.$route.params.slug || false;
      },
      getNextStory() {
        return this.$dataEngine.nextStory;
      },
      getCurrentStory() {
        // return {};
        return this.$store.getters.getStoryV3(this.slug) || {};
      },
      metaPublishers() {
        return this.getCurrentStory?.meta?.cx_pub || 0; 
      },
      metaUpdates() {
        return this.getCurrentStory?.clusters?.stats?.timeseries || 0; 
      },
      metaRunningTime() {
        let dLast = new Date(this.getCurrentStory.last_published_at).getTime();
        let dFirst = this.getCurrentStory?.clusters?.timeseries.map((a) => {return new Date(a.stats.mid).getTime()}).sort((a, b) => a > b ? 1 : -1)[0];
        // console.log("AGE: ", dFirst);
        let iOffset = (dLast - dFirst) / (86400 * 1000);
        return Math.max(1, iOffset);
      },

      readState() {
        return this.$store.getters.readState(this.slug) || {};
      },

      getTimeline() {
        let aTimeline = this.getCurrentStory?.events?.length ? this.getCurrentStory?.events : [];
        // re-order
        // aTimeline.reverse();
        // get the average
        let avg = parseFloat((aTimeline.reduce((c, n) => c + n.score, 0) / aTimeline.length).toFixed(1));
        // remove anything below the average
        // console.log(`TIMELINE: `, avg, aTimeline);
        aTimeline = aTimeline.filter(a => a.score > avg);
        // return 
        return aTimeline;
      },

      getSourcesHtml() {
        const sources = Object.values(this.sources);
        if (sources.length === 0) return false;

        const hasUrls = sources.every(s => s.pub.article?.url);
        if (!hasUrls) return;

        const parts = [];
        const max = 3;
        const count = sources.length;
        const displayCount = Math.min(count, max);

        for (let i = 0; i < displayCount; i++) {
          const s = sources[i];
          parts.push(`
            <div>
              <img src="${s.pub.icon}" onerror="this.style.display='none'"/>
              <a target="_blank" data-click="outclick" data-article="${s.slug}">
                ${s.pub.name}
              </a>
            </div>
          `);
        }

        let suffix = '';
        if (count > 3) suffix = ` and <a>${count - 3} other ${(count - 3) > 1 ? 'sources' : 'source'}</a> are all reporting on this story.`;
        else if (count === 3) suffix = ` are all reporting on this story.`;
        else if (count === 2) suffix = ` are reporting on this story.`;
        else if (count === 1) suffix = ` is reporting on this story.`;

        return parts.join(',\n') + suffix;
      },


      // getSourcesHtml() {
      //   let sources = this.$dataEngine.storyPublishersGet();

      //   console.log('sources', sources);

      //   let html = false;

      //   if (Object.keys(sources).length > 3) {
      //     // 3 or more sources
      //     html = `
      //       <div><img src="${Object.values(sources)[0].pub.icon}"/> <a href="${Object.values(sources)[0].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[0].slug}">${Object.values(sources)[0].pub.name}</a></div>,
      //       <div><img src="${Object.values(sources)[1].pub.icon}"/> <a href="${Object.values(sources)[1].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[1].slug}">${Object.values(sources)[1].pub.name}</a></div>,
      //       <div><img src="${Object.values(sources)[2].pub.icon}"/> <a href="${Object.values(sources)[2].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[2].slug}">${Object.values(sources)[2].pub.name}</a></div> and
      //        ${Object.keys(sources).length - 3} other sources are all reporting on this story.
      //     `
      //   } else if (Object.keys(sources).length == 3) {
      //               console.log('??', Object.values(sources)[0])

      //     // 3 sources reporting
      //     html = `
      //       <div><img src="${Object.values(sources)[0].pub.icon}"/> <a href="${Object.values(sources)[0].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[0].slug}">${Object.values(sources)[0].pub.name}</a></div>,
      //       <div><img src="${Object.values(sources)[1].pub.icon}"/> <a href="${Object.values(sources)[1].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[1].slug}">${Object.values(sources)[1].pub.name}</a></div>,
      //       <div><img src="${Object.values(sources)[2].pub.icon}"/> <a href="${Object.values(sources)[2].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[2].slug}">${Object.values(sources)[2].pub.name}</a></div> 
      //        are all reporting on this story.
      //     `
      //   } else if (Object.keys(sources).length == 2) {
      //     // 2 sources reporting
      //     html = `
      //       <div><img src="${Object.values(sources)[0].pub.icon}"/> <a href="${Object.values(sources)[0].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[0].slug}">${Object.values(sources)[0].pub.name}</a></div> and
      //       <div><img src="${Object.values(sources)[1].pub.icon}"/> <a href="${Object.values(sources)[1].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[1].slug}">${Object.values(sources)[1].pub.name}</a></div>
      //        are reporting on this story.
      //     `
      //   } else if (Object.keys(sources).length == 1) {
      //     // 1 source reporting
      //     html = `
      //       <div><img src="${Object.values(sources)[0].pub.icon}"/> <a href="${Object.values(sources)[0].pub.article?.url}" target="_blank" data-click="outclick" data-article="${Object.values(sources)[0].slug}">${Object.values(sources)[0].pub.name}</a></div>
      //        is reporting on this story.
      //     `
      //   }

      //   return html;
      // },

      isV5Modal () {
        return ['v5', 'news'].includes(this.$route.fullPath.replace(/^\//,'').split('/')[0]);
      },

      getCloseButtonContext() {
        return this.isV5Modal ? 'modal' : (history.length <= 1 ? 'external' : 'news');
      },

      getCloseButtonText() {
        switch (this.getCloseButtonContext) {
          case 'external': return 'More Personalised Stories';
          case 'news': return 'Back';
          case 'modal': return 'Back To Stories';
          default: return 'Close';
        }
      },
      
      getNodeProgress() {
        let node0 = document.querySelector('.node-body[data-index="0"]');
        // if (!node0) return 0;

        let node0Offset = node0?.getBoundingClientRect()?.top || 0;
        let node0Height = node0?.clientHeight || 0;

        let sProgress =  Math.max(0, Math.min(100, (this.iScrollPos / (node0Offset + node0Height + window.innerHeight)) * 100 )) + '%';
        // console.log(node0Offset, node0Height, window.innerHeight, ' - ', node0Offset + node0Height + window.innerHeight, this.iScrollPos, sProgress);
        return sProgress;
        // return Math.round((this.iScrollPos / ( document.getElementById('app')?.clientHeight - window.innerHeight ) * 100), 2) + '%';
      },

      focusCountries() {
        if (!this.getCurrentStory || this.getCurrentStory?.locales?.length <= 0) { 
          return false;
        }
        const locales = [];
        this.getCurrentStory.locales.forEach(locale => {
          locales.push(locale.iso.toUpperCase());
        })
        return locales;
      },
    },

    methods: {
      showSources() {
        this.EventBus.$emit('modal:publishers',{ publishers: Object.values(this.sources).map(oublisher => oublisher.pub) });
      },

      goPro() {
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      },

      showSignUp() {
        this.$store.commit("updateShowModal", 'skip');
      },

      closeStory() {
        switch (this.getCloseButtonContext) {
          case 'external': this.$router.push('/'); return;
          // case 'modal': this.EventBus.$emit('modal:full-story-close'); return;
          case 'news': this.$router.back(); return;
          default: this.$router.back(); return;
        }
      },

      didSelectBack() {
        this.$router.back();
      },

      didSelectMobileDial() {
        this.showGoalOverlay = !this.showGoalOverlay
      },

      getReadStateIcon(code) {
        if (code) {
          if (code === 'skimmed' || code === 'read') {
            return 'double-tick'
          }

          return 'single-tick'
        }
      },

      getReadStateColor(code) {
        switch (code) {
          case 'preview': return '#6D7479'
          case 'glanced': return '#6D7479'
          case 'skimmed': return '#6D7479'
          case 'read': return '#14B31F'
        }
      },

      headClick() {
        // console.log("Head click..");
        window.scrollTo({top: 0, behavior: 'smooth'});
      },
      
    },

    async mounted() {
      this.sources = this.$dataEngine.storyPublishersGet();

      window.addEventListener('scroll', () => {
        this.iScrollPos = window.pageYOffset;
        //// console.log(this.iScrollPos, this.getNodeProgress);
      });
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';
  @import 'src/assets/scss/v5.scss';

  .feature-tags {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 0.5rem;
  }

  // .story-timeline {
  //   margin-top: 2em;
  //   color: $neutral-400;
  //   h4 {
  //     font-size: 1.25em;
  //     margin-bottom: 1em;
  //     font-weight: bold;
  //     display: inline-block;
  //     border-bottom: 2px solid #FFDE00;
  //   }

  //   .timeline {
  //     display: flex;
  //     align-items: flex-start;

  //     .item {
  //       display: flex;
  //       flex-direction: column;
  //       align-items: flex-start;
  //       gap: 0.25rem;
  //       margin-bottom: 1.5rem;
  //       padding-left: 1rem;
  //       border-left: 1px solid rgba($neutral-400, 0.5);
        
  //       .when {
  //         display: block;
  //       }
  //       .description {
  //         display: block;
  //       }
  //     }
  //   }
  // }


  .story-sources {
    margin-bottom: 0.5rem;
    &::v-deep {
      color: $neutral-400;

      p {
        font-size: 0.8rem;
      }

      div {
        display: inline;
        white-space: nowrap;
      }

      img {
        width: 1rem;
        height: 1rem;
        object-fit: cover;
        border-radius: 100%;
        position: relative;
        top: 2px;
      }
    }
  }

  .mobile-cta {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .cluster-meta {
    display: flex;
    flex-direction: column;
    height: $desktop-grid-height;
    flex: 1;
    border-left: 1px solid rgba($neutral-400, 0.25);
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    background: $neutral-600;

    .darkmode & {
      background: $neutral-100;
    }

    .desktop & {
      .darkmode & {
        background: $neutral-100;
      }
    }

    .desktop & {
      height: calc($desktop-grid-height - 35px);
    }

    @media (max-width: 850px) {
      border-top: 1px solid rgba($neutral-400, 0.25);
      border-left: 0;
      padding-bottom: 4.1rem;
    }

    // display: flex;
    // flex-flow: row wrap;
    // align-content: space-between;
    // width: 100%;

    // background: rgba($neutral-500, 0.2);

    // .darkmode & {
    //   background: $neutral-200;
    // }

    // .context-v5 & {
    //   display: none;
    // }

    .desktop & {
      &.cluster-desktop {
        // CAREFUL - This really effects the pos:sticky:bottom
        // display: inline-block;
        // height: 100%;
      }

      // &.cluster-mobile {
      //   display: none;
      // }
    }

    .cluster-bottom {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      backdrop-filter: blur(2px);

      button {
        border-radius: 500px;
        margin-top: 0.5rem;
      }
    }

    // .mobile.is-app & {
    //   &.cluster-mobile {
    //     top:0;
    //   }
    // }
    .mobile & {
      // &.cluster-desktop {
      //   display: none;
      // }

      &.cluster-mobile {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-bottom: calc(env(safe-area-inset-bottom));
        padding: 0.75rem 1rem 0 1rem;
        background: rgba($neutral-600, 0.95);

        .darkmode & {
          background: rgba($neutral-100, 0.95);
        }

        &.cluster-bottom {
          flex-direction: row;
          justify-content: space-between;
          
          button, .share-btn {
            margin-bottom: 0.75rem;
          }
        }

        // .node-header-mini {
        //   display: flex;
        //   flex-direction: row;
        //   align-items: center;
        //   justify-content: space-between;
        //   padding: 0.6em 0.8em;
          
        //   @include palette-default;
        //   @include palette-border-bottom;

        //   h1 {
        //     @include typo-size-heading;
        //     @include limit-1-line;
        //     margin: 0 1em 0.4em 0;
        //   }

        //   .content-meta {
        //     display: flex;
        //     align-items: center;

        //     .icon {
        //       margin-bottom: 2px;
        //     }

        //     .meta-byline {
        //       @include typo-size-body-small;
        //       margin-left: 0.5em;
        //       font-weight: normal;

        //       .callout {
        //         font-weight: bold;
        //       }
        //     }
        //   }
        // }

        // .node-header-mini-progress {
        //   height: 3px;
        //   background: $green-tone-3;
        //   transition: width .3s;
        // }
      }
    }

    .inner-dial {
      display: flex;
      background: $base-primary;
      padding: 0.2em 0.5em;
      border-radius: $el-border-radius;
      color: $white-primary;

      .desktop & {
        margin-bottom: 1em;
      }

      .mobile & {
        height: 75px;
        border-radius: 0;

        .dial-container {
          padding-left: 10px;
        }
      }

      h3 {
        @include typo-size-small-heading;
        max-width: 4em;
      }
    }

    .context-v5 & {
      .desktop & {
        .inner.top {
          top: 1em;
        }
      }
    }

    // DESKTOP - Stuck top & bottom of RHP
    .desktop & {
      .inner-dial {
        .dial-small {
          display: none;
        }
      }
      .inner {
        &.top {
          // flex: 0 0;
          width: 100%;
          align-self: flex-start;
          // @include sticky-meta;
          // border: 1px dotted red;

          // .darkmode & {
          //   background: $neutral-200;
          // }
        }
        
        &.bottom {
           // flex: 1;
          width: 100%;
          align-self: flex-end;
          // @include sticky-meta-bottom;
          // border: 1px dotted red;
          // bottom: 7rem;

          .progress {
            margin-top: 0.5rem;
          }
        }
      }
    }

    // MOBILE - Stuck top & bottom of Viewport
    .mobile & {
      z-index: 100;
      .inner-dial {
        .dial-medium {
          display: none;
        }
      }
      .inner {
        &.top {
          position: fixed;
          top: calc(env(safe-area-inset-top) + $header-height);
          left: 0;
          right: 0;
          height: 30px;
          background: $white-primary;
        }

        &.bottom {
          z-index: 10;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          // height: 40px;
          background: white;
          // border-top: 1px solid #e5e5e5;
          // box-shadow: 0px -20px 20px 0px rgb(0 0 0 / 20%);

          // flex the dial & next story
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          display: none;

          .inner-dial {
            h3 {
              display: none;
            }
            .dial-small {
              &.dial-container {
                // border-left: 1px solid #e5e5e5;
                // padding-left: 12px;
              }
            }
          }
        }
      }

      .goal-overlay {
        z-index: 5;
        min-height: 80px + (16px * 2);
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        bottom: -40px;
        background: $base-primary;
        width: 100%;
        color: $white-primary;
        padding: 1em;
        transition: bottom .2s ease-out;
        box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);

        &.fold-out {
          bottom: 75px;
        }

        h3 {
          @include typo-size-heading;
        }
      }
    }
    .mobile.is-app & {
      .inner.top {
        top: 0;
      }
    }
  }

  .goal-overlay {
    .desktop & {
      display: none;
    }
  }













  .cta-states {
    .mobile & {
      display: none;
    }
  }

  .section-sign-up,
  .section-go-pro {
    margin-bottom: 1em;
    cursor: pointer;

    .mobile & {
      margin-bottom: 0;
    }

    .inner-section-content {
      border-radius: $el-border-radius;
      display: flex;
      align-items: center;
      padding: 0.5em 1em;

      .inner-content {
        @include typo-size-body-small;
        flex: 1;
        margin: auto 1em auto auto;

        p {
          margin: 0;
          padding-top: 2px;
        }

        .callout {
          display: inline;
          font-weight: bold
        }
      }

      button {
        @include base-btn;
      }
    } 
  }
  
  .section-sign-up {
    .inner-section-content {
      background: $yellow-tone-3;
      color: $yellow-tone-7;

      button {
        background: $white-primary;
      }
    }
  }

  .section-go-pro {
    .inner-section-content {
      background: $green-tone-3;

      .inner-content {
        color: $white-primary;
      }

      button {
        background: $green-tone-4;
        color: $white-primary;
      }
    }
  }

  .key-updates {
    display: flex;
    flex-direction: column;

    .go-back {
      display: none;
    }

    .mobile & {
      flex-direction: row;
      align-items: center;
      display: -webkit-box;
      overflow-x: scroll;
      overflow-y: hidden;
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      padding: 0.2em 0.2em;
      @include box-fixed;

      .go-back {
        display: inline-block;
        padding: 0em 0.8em;
        margin-top: 5px;
      }
    }

    .key-update {
      padding: 1.5em 1em;
      background: $yellow-tone-3;
      color: $yellow-tone-7;
      border-radius: $el-border-radius;
      @include typo-size-small;

      &:not(:last-child) {
        margin-bottom: 0.6em;
      }

      .mobile & {
        padding: 0.5em 1em;
        background: $yellow-tone-1;

        &.go-pro {
          background: $green-tone-3;
          color: $white-primary;
        }

        &.sign-up {
          background: $yellow-tone-3;
        }

        &:not(:last-child) {
          margin-bottom: 0;
          margin-right: 0.6em;
        }
      }
    }
  }

  .tags {
    display: flex;
    flex-direction: column;
    margin: 2em 0;

    &::-webkit-scrollbar {
      display: none;
    }

    .tag {
      cursor: pointer;
    }
  }

  .track {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  .aside-group {
    position: sticky;
    bottom: 0;
    border-top: 1px solid rgba($neutral-400, 0.25);
  }

  .aside-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    border-bottom: 1px solid rgba($neutral-400, 0.25);
    background: $neutral-600;

    .darkmode & {
      background: $neutral-100;
    }

    .desktop & {
      .darkmode & {
        background: $neutral-100;
      }
    }

    .inner-section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .flex-width {
      margin-top: 0.5rem;
    }

    h4 {
      font-size: 0.9rem;
      font-weight: bold;
      color: $neutral-400;
    }

    &.qr {
      padding: 1rem 2rem;

        @media (max-width: 820px) {
        padding: 1rem 1rem;
      }
    }

    &.map {
      padding-bottom: 0;
    }

    &.cta {
      border-bottom: 0;
      
      .mobile-cta {
        max-width: 350px;
        margin: 1rem auto;
      }
    }

    &.story-timeline {
      padding: 1.5rem 1rem;

      .timeline {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        .item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.25rem;
          padding-left: 1rem;
          border-left: 2px solid rgba($neutral-400, 0.5);
          
          .when {
            display: block;
          }

          .description {
            display: block;
          }
        }
      }
    }
  }
</style>